// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store/store'
import Toasted from 'vue-toasted';
import moment from 'moment'
import Notifications from 'vue-notification';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueGoogleCharts from 'vue-google-charts'
import VueObserveVisibility from 'vue-observe-visibility';
const VueScrollTo = require('vue-scrollto')
import * as GmapVue from 'gmap-vue'
import vmodal from 'vue-js-modal'
    Vue.use(vmodal)

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

Vue.use(VueObserveVisibility);

Vue.use(Notifications);
Vue.use(VueSweetalert2);

Vue.use(GmapVue, {
  load: {
    key: "AIzaSyDXOnI0akFQqykkZZMrqC2R5JiSWBolzmU",
    libraries: "places", // necessary for places input,
    v: 3.38
  }
});


const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

Vue.use(Toasted, {
  singleton: true,
  iconPack: 'fontawesome'
})

Vue.use(VueScrollTo)
Vue.use(require('vue-moment'));
Vue.use(VueGoogleCharts)


import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEdit, faFont, faAlignLeft,
  faImage, faArrowsAltH, faHome, faCog, faCogs, faCubes, faTimes, faClock, faListOl,
          faIndustry, faCheck, faPowerOff, faBars, faSpinner, faCircle, faMinusCircle,
          faPlus, faExclamationTriangle, faMapMarkerAlt, faAddressCard, faUsers, faPaperPlane,
          faList, faCloudUploadAlt, faChartLine, faChartBar, faBolt, faThermometerHalf,
          faTachometerAlt, faSave, faSyncAlt, faSitemap, faChevronLeft, faChevronRight,
          faStar, faFileExcel, faCodeBranch, faSearch, faSquareRootAlt, faCopy, faPlusSquare,
          faMinusSquare, faThumbsUp, faExchangeAlt, faFileAlt, faExpand, faCompress,
          faCloudDownloadAlt, faFileInvoice, faChevronUp, faPrint, faChevronCircleRight, faChevronDown,
          faCircleNotch, faLongArrowAltUp, faLongArrowAltDown, faSync, faLock, faUnlock,
          faWind,faFire, faBurn, faTint, faLightbulb, faStarOfLife, faFaucet, faTable, faTrashAlt, faUserSecret, faCommentAlt, faArrowsAltV,
          faHardDrive, faArrowRight, faDownload, faBan, faXmark, faRectangleXmark, faRulerHorizontal, faEnvelope, faArrowsRotate,
  faDatabase, faPlug, faBell, faSmog, faEuroSign, faAsterisk, faScissors, faTurnDown, faTurnUp, faCircleXmark, faCalendarAlt, faAngleDoubleRight,
          faMoneyBillWave, faEye
        } from '@fortawesome/free-solid-svg-icons';


library.add([faImage, faAlignLeft, faFont, faEdit, faArrowsAltH,
  faHome, faCog, faCogs, faCubes, faTimes, faIndustry, faCheck, faClock, faListOl,
            faPowerOff, faBars, faSpinner, faCircle, faMinusCircle,
            faPlus, faExclamationTriangle, faMapMarkerAlt, faAddressCard, faUsers, faPaperPlane,
            faList, faCloudUploadAlt, faChartLine, faChartBar, faBolt, faThermometerHalf,
            faTachometerAlt, faSave, faSyncAlt, faSitemap, faChevronLeft, faChevronRight,
            faStar, faFileExcel, faCodeBranch, faSearch, faSquareRootAlt, faCopy, faPlusSquare,
            faMinusSquare, faThumbsUp, faExchangeAlt, faFileAlt, faExpand, faCompress,
            faCloudDownloadAlt, faFileInvoice, faChevronUp, faPrint, faChevronCircleRight, faChevronDown,
            faCircleNotch,faLongArrowAltUp,faLongArrowAltDown, faSync, faLock, faUnlock,
            faWind,faFire, faBurn, faTint, faLightbulb, faStarOfLife, faFaucet, faTable, faTrashAlt, faUserSecret, faCommentAlt, faArrowsAltV,
            faHardDrive, faArrowRight, faDownload, faBan, faXmark, faRectangleXmark, faRulerHorizontal, faEnvelope, faArrowsRotate,
  faDatabase, faPlug, faBell, faSmog, faEuroSign, faAsterisk, faScissors, faTurnDown, faTurnUp, faCircleXmark, faCalendarAlt, faAngleDoubleRight,
  faMoneyBillWave, faEye
])

Vue.component('font-awesome-icon', FontAwesomeIcon)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/app.css'

var Volta = {
  methods: {
    findGetParameter: function(parameterName) {
      var result = null,
          tmp = [];
      location.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
          });
      return result;
    },
    getChartsLocales: function () {
      return [{
        "name": "it",
        "options": {
          "months": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
          "shortMonths": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
          "days": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
          "shortDays": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
          "toolbar": {
              "exportToSVG": "Download SVG",
              "exportToPNG": "Download PNG",
              "menu": "Menu",
              "selection": "Selezione",
              "selectionZoom": "Selezione Zoom",
              "zoomIn": "Zoom In",
              "zoomOut": "Zoom Out",
              "pan": "Panning",
              "reset": "Reset Zoom"
          }
        }
      }]
    }
  },
}

Vue.mixin(Volta)

Vue.use(BootstrapVue);
Vue.config.productionTip = false

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

Vue.filter('userLevel', function(value) {
  if (value == 1) return "Super Admin"
  if (value == 2) return "Admin"
  if (value == 3) return "Utente"
})

Vue.filter('slugify', function(str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
  var to   = "aaaaaeeeeeiiiiooooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
})

Vue.filter('formatDecimal', formatDecimal)

function formatDecimal(str, prec) {
  if(str == null)
    return '';

  let val = (str/1)

  if (prec === undefined) {
    prec = val < 1 ? 2 : 0;
  }

  val = val.toFixed(prec).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
}



// WEBPACK FOOTER //
// ./src/main.js